<template>
  <layout name="BaseLayout">
    <div>
      <v-data-table ref="dataTable" dense :headers="tableHeaders" :items="items" :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc" class="elevation-1" :loading="loading" :loading-text="loadingText" :footer-props="{
          itemsPerPageOptions: rowsPerPage,
          itemsPerPageAllText: allTextForPerPage,
          itemsPerPageText: itemsPerPageText,
        }" :options="options" :no-results-text="filtersNoResultText" :multi-sort="true">
        <!-- formatear el texto de la paginacion -->
        <template v-slot:footer.page-text="props">
          {{ props.pageStart }} - {{ props.pageStop }} de
          {{ props.itemsLength }}
        </template>

        <!-- formatear columna de fecha inicio matricula -->
        <template v-slot:item.precioBase="{ item }">
          {{ item.precioBase | formatFloat }}
        </template>

        <!-- formatear columna de fecha inicio prematricula -->
        <template v-slot:item.fechaInicioPrematricula="{ item }">
          {{ item.fechaInicioPrematricula | formatDateDDMMYYYY }}
        </template>

        <!-- formatear columna de fecha fin prematricula -->
        <template v-slot:item.fechaFinPrematricula="{ item }">
          {{ item.fechaFinPrematricula | formatDateDDMMYYYY }}
        </template>

        <!-- formatear columna de fecha inicio matricula -->
        <template v-slot:item.fechaInicioMatricula="{ item }">
          {{ item.fechaInicioMatricula | formatDateDDMMYYYY }}
        </template>

        <!-- formatear columna de fecha fin matricula -->
        <template v-slot:item.fechaFinMatricula="{ item }">
          {{ item.fechaFinMatricula | formatDateDDMMYYYY }}
        </template>

        <!-- formatear columna de fecha fin matricula -->
        <template v-slot:item.horaInicioMatricula="{ item }">
          {{ horarioMatriculaString(item) }}
        </template>

        <template v-slot:top>
          <v-toolbar text color="white">
            <v-toolbar-title>Cursos</v-toolbar-title>

            <v-divider class="mx-4" inset vertical />

            <v-btn :loading="loading" :disabled="loading" @click="refreshItems" text color="primary">
              Actualizar
              <v-icon right dark>mdi-refresh</v-icon>
            </v-btn>

            <template v-if="userCanEdit && isShowActionsSorteo()">
              <v-divider class="mx-4" inset vertical />

              <span>{{ nombreSorteo(1) }}</span>


              <v-text-field label="Número F1" class="w100 input-right-text mt-1 pb-0 ml-3" dense
                v-model="numeroDeSorteoFase1" :hint="numeroMaxDeSorteoHint(1, 1)" persistent-hint
                :disabled="loadingAccionAsignarHorariosFase1 || !isPendingSorteo(1, 1)" />

              <div class="d-flex flex-column align-center justify-center mr-9">
                <v-btn @click="asignarHorariosSorteo(1, 1)" text color="primary" class="height-25"
                  :loading="loadingAccionAsignarHorariosFase1"
                  :disabled="loadingAccionAsignarHorariosFase1 || !isPendingSorteo(1, 1)">
                  Asignar horarios F1
                </v-btn>


                <v-btn @click="enviarEmailsSorteo(1, 1)" text color="primary" class="height-25"
                  :loading="loadingAccionEnvioEmailsFase1"
                  :disabled="loadingAccionEnvioEmailsFase1 || !isPendingAviso(1, 1)">
                  Enviar emails F1
                </v-btn>
              </div>

              <v-text-field label="Número F2" class="w100 input-right-text mt-1 pb-0 ml-3" dense
                v-model="numeroDeSorteoFase2" :hint="numeroMaxDeSorteoHint(1, 2)" persistent-hint
                :disabled="loadingAccionAsignarHorariosFase2 || !isPendingSorteo(1, 2)" />

              <div class="d-flex flex-column align-center justify-center mr-9">
                <v-btn @click="asignarHorariosSorteo(1, 2)" text color="primary" class="height-25"
                  :loading="loadingAccionAsignarHorariosFase2"
                  :disabled="loadingAccionAsignarHorariosFase2 || !isPendingSorteo(1, 2)">
                  Asignar horarios F2
                </v-btn>

                <v-btn @click="enviarEmailsSorteo(1, 2)" text color="primary" class="height-25"
                  :loading="loadingAccionEnvioEmailsFase2"
                  :disabled="loadingAccionEnvioEmailsFase2 || !isPendingAviso(1, 2)">
                  Enviar emails F2
                </v-btn>
              </div>

              <v-text-field label="Número F3" class="w100 input-right-text mt-1 pb-0 ml-3" dense
                v-model="numeroDeSorteoFase3" :hint="numeroMaxDeSorteoHint(1, 3)" persistent-hint
                :disabled="loadingAccionAsignarHorariosFase3 || !isPendingSorteo(1, 3)" />

              <div class="d-flex flex-column align-center justify-center mr-9">
                <v-btn @click="asignarHorariosSorteo(1, 3)" text color="primary" class="height-25"
                  :loading="loadingAccionAsignarHorariosFase3"
                  :disabled="loadingAccionAsignarHorariosFase3 || !isPendingSorteo(1, 3)">
                  Asignar horarios F3
                </v-btn>

                <v-btn @click="enviarEmailsSorteo(1, 3)" text color="primary" class="height-25"
                  :loading="loadingAccionEnvioEmailsFase3"
                  :disabled="loadingAccionEnvioEmailsFase3 || !isPendingAviso(1, 3)">
                  Enviar emails F3
                </v-btn>
              </div>
            </template>

            <template v-if="userCanEdit">
              <v-spacer />
            </template>
          </v-toolbar>
        </template>

        <!-- Se muestra con resultado vacio -->
        <template v-slot:no-data>
          {{ filtersNoResultText }}
        </template>
      </v-data-table>

      <!-- popup de confirmación de borrado -->
      <confirm ref="cursoConfirm" />
    </div>
  </layout>
</template>

<script>
import Layout from "@/components/layouts/Layout";
import Confirm from "@/components/Confirm";
import { mapGetters, mapMutations } from "vuex";
import {
  getCursosByAnioDesc as getCursos,
  sortear,
  enviarEmails,
} from "@/api/cursos.api";
import { getNumeroMaximoSorteo } from "@/api/prematriculas.api";
import DateUtils from "@/libraries/DateUtils";

export default {
  name: "Cursos",

  components: {
    Layout,
    Confirm,
  },

  data: () => ({
    items: [],
    headers: [],
    sortBy: "anio",
    sortDesc: true,
    rowsPerPage: [25, 50, 75, 100, -1],
    options: { itemsPerPage: 25, },
    loading: false,
    numeroDeSorteoSelectedFase1: null,
    numeroDeSorteoSelectedFase2: null,
    numeroDeSorteoSelectedFase3: null,
    accionSortearEjecutadaFase1: false,
    accionSortearEjecutadaFase2: false,
    accionSortearEjecutadaFase3: false,
    accionAvisarSorteoEjecutadaFase1: false,
    accionAvisarSorteoEjecutadaFase2: false,
    accionAvisarSorteoEjecutadaFase3: false,
    loadingAccionAsignarHorariosFase1: false,
    loadingAccionAsignarHorariosFase2: false,
    loadingAccionAsignarHorariosFase3: false,
    loadingAccionEnvioEmailsFase1: false,
    loadingAccionEnvioEmailsFase2: false,
    loadingAccionEnvioEmailsFase3: false,
    numeroMaxDeSorteo: [],
    filtersNoResultText: "No se han encontrado resultados",
    loadingText: "Cargando ...",
    itemsPerPageText: "Filas por página:",
    allTextForPerPage: "Todas",

    // Administracion de roles de usuario
    authorizedRoles: ["ROLE_SUPER_ADMIN"],
  }),

  beforeMount() {
    if (
      this.$store.getters["Auth/authRoles"] !== undefined &&
      !this.authorizedRoles.includes(this.$store.getters["Auth/authRoles"][0])
    ) {
      this.loading = false;
      this.$router.push("/prematriculas");
    }
  },

  created() {
    this.initialize();
  },

  computed: {
    ...mapGetters("App", {
      cursoActual: "GET_CURSO_ACTUAL",
      localizaciones: "GET_LOCALIZACIONES",
    }),

    ...mapGetters("Auth", {
      userCanEdit: "userCanEdit",
    }),

    tableHeaders() {
      return this.headers;
    },

    numeroDeSorteoFase1: {
      get: function () {
        return this.localizaciones?.find((loc) => loc.id === 1).ultimoCurso.numSorteoFase1 || null;
      },

      set: function (value) {
        this.numeroDeSorteoSelectedFase1 = value;
      },
    },

    numeroDeSorteoFase2: {
      get: function () {
        return this.localizaciones?.find((loc) => loc.id === 1).ultimoCurso.numSorteoFase2 || null;
      },

      set: function (value) {
        this.numeroDeSorteoSelectedFase2 = value;
      },
    },

    numeroDeSorteoFase3: {
      get: function () {
        return this.localizaciones?.find((loc) => loc.id === 1).ultimoCurso.numSorteoFase3 || null;
      },

      set: function (value) {
        this.numeroDeSorteoSelectedFase3 = value;
      },
    },
  },

  methods: {
    async getNumeroMaxSorteo() {
      await getNumeroMaximoSorteo().then(
        (response) => (this.numeroMaxDeSorteo = response.data.values)
      );
    },

    ...mapMutations("Snack", {
      setSnack: "SET_SNACK_OPTIONS",
    }),

    async initialize() {
      this.loading = true;

      this.headers = [
        {
          text: "Id Curso",
          align: "start",
          value: "id",
        },
        {
          text: "Año",
          align: "start",
          value: "anio",
        },
        {
          text: "Precio Base",
          align: "end",
          value: "precioBase",
        },
        {
          text: "Inicio Prematricula",
          align: "start",
          value: "fechaInicioPrematricula",
        },
        {
          text: "Fin Prematricula",
          align: "start",
          value: "fechaFinPrematricula",
        },
        {
          text: "Inicio Matricula",
          align: "start",
          value: "fechaInicioMatricula",
        },
        {
          text: "Fin Matricula",
          align: "start",
          value: "fechaFinMatricula",
        },
        {
          text: "Horario Matricula",
          align: "start",
          value: "horaInicioMatricula",
        },
      ];

      if (this.userCanEdit) {
        this.headers.push({ text: "", value: "actions", sortable: false });
      }

      await getCursos().then((response) => (this.items = response.data));

      this.getNumeroMaxSorteo();
      this.loading = false;
    },

    async refreshItems() {
      this.loading = true;
      this.items = [];
      await getCursos().then((response) => (this.items = response.data));
      this.loading = false;
    },

    isShowActionsSorteo() {
      if (this.cursoActual == null) {
        return false;
      }

      let fechaActual = new Date();
      let anioActual = fechaActual.getFullYear();
      let anioCursoActual = parseInt(this.cursoActual.anio);

      return anioCursoActual == anioActual;
    },

    isPendingSorteo(idLocalizacion, fase) {
      if (0 === this.localizaciones.length) {
        return false;
      }

      return (
        this.localizaciones.find(
          (localizacion) => localizacion.id === idLocalizacion
        ).ultimoCurso[`sorteadoFase${fase}`] == false && this[`accionSortearEjecutadaFase${fase}`] == false
      );
    },

    isPendingAviso(idLocalizacion, fase) {
      if (0 === this.localizaciones.length) {
        return false;
      }

      return (
        this.localizaciones.find(
          (localizacion) => localizacion.id === idLocalizacion
        ).ultimoCurso[`sorteadoFase${fase}`] == true &&
        this.localizaciones.find(
          (localizacion) => localizacion.id === idLocalizacion
        ).ultimoCurso[`avisadoFase${fase}`] == false &&
        this[`accionAvisarSorteoEjecutadaFase${fase}`] == false
      );
    },

    async asignarHorariosSorteo(idLocalizacion, fase) {
      const localizacion = this.localizaciones.find(
        (localizacion) => localizacion.id === idLocalizacion
      );

      let title = `Realizar sorteo ${localizacion.nombre} y fase ${fase}`;
      let subtitle = "¿Estás seguro?";
      let message =
        "Se va a realizar el sorteo de horarios para las matriculaciones del curso actual";
      let message2 = null;

      if (
        await this.$refs.cursoConfirm.open(title, subtitle, message, message2, {
          color: "primary",
          width: 400,
        })
      ) {
        this[`loadingAccionAsignarHorariosFase${fase}`] = true;

        await sortear(idLocalizacion, this[`numeroDeSorteoSelectedFase${fase}`], fase)
          .then((response) => {
            if (response.status == 200) {
              this.setSnack({
                active: true,
                timeout: 1500,
                color: this.$getStringFor("snack", "successColor"),
                text: "Sorteo realizado correctamente",
              });
              this[`accionSortearEjecutadaFase${fase}`] = true;
              this.cursoActual.sorteado = true;
            } else {
              this.setSnack({
                active: true,
                timeout: 1500,
                color: this.$getStringFor("snack", "errorColor"),
                text: "No ha sido posible realizar el sorteo",
              });
            }

            this.$store.dispatch("App/INITIALIZE_LOCALIZACIONES");
          })
          .catch((error) => {
            console.error(error);
            this.setSnack({
              active: true,
              timeout: 1500,
              color: this.$getStringFor("snack", "errorColor"),
              text: "No ha sido posible realizar el sorteo",
            });
          });

        this[`loadingAccionAsignarHorariosFase${fase}`] = false;
      }
    },

    async enviarEmailsSorteo(idLocalizacion, fase) {
      const localizacion = this.localizaciones.find(
        (localizacion) => localizacion.id === idLocalizacion
      );

      let title = `Enviar emails ${localizacion.nombre}`;
      let subtitle = "¿Estás seguro?";
      let message =
        "Se va a realizar el envío de emails con la información de horarios para las matriculaciones del curso actual";
      let message2 = null;

      if (
        await this.$refs.cursoConfirm.open(title, subtitle, message, message2, {
          color: "primary",
          width: 400,
        })
      ) {
        this[`loadingAccionEnvioEmailsFase${fase}`] = true;

        await enviarEmails(idLocalizacion, fase)
          .then((response) => {
            if (response.status == 200) {
              this.setSnack({
                active: true,
                timeout: 1500,
                color: this.$getStringFor("snack", "successColor"),
                text: "Envíos realizados correctamente",
              });
              this[`accionAvisarSorteoEjecutadaFase${fase}`] = true;
            } else {
              this.setSnack({
                active: true,
                timeout: 1500,
                color: this.$getStringFor("snack", "errorColor"),
                text: "No ha sido posible realizar los envíos",
              });
            }

            this.$store.dispatch("App/INITIALIZE_LOCALIZACIONES");
          })
          .catch((error) => {
            console.error(error);
            this.setSnack({
              active: true,
              timeout: 1500,
              color: this.$getStringFor("snack", "errorColor"),
              text: "No ha sido posible realizar los envíos",
            });
          });

        this[`loadingAccionEnvioEmailsFase${fase}`] = false;
      }
    },

    horarioMatriculaString(value) {
      const dateUtilsInicio = new DateUtils(value.horaInicioMatricula);
      const dateUtilsFin = new DateUtils(value.horaFinMatricula);

      let horaInicio = dateUtilsInicio.formatDateHHII();
      let horaFin = dateUtilsFin.formatDateHHII();

      if (horaInicio != "" && horaFin != "") {
        return `De ${horaInicio} a ${horaFin}`;
      }

      return "";
    },

    numeroMaxDeSorteoHint(idLocalizacion, fase) {
      if (0 === this.numeroMaxDeSorteo.length) {
        return "";
      }

      return `Nº Max: ${this.numeroMaxDeSorteo[idLocalizacion][fase]}`;
    },

    nombreSorteo(idLocalizacion) {
      if (0 === this.localizaciones.length) {
        return `Sorteo ??`;
      }

      return `Sorteo ${this.localizaciones.find(
        (localizacion) => localizacion.id === idLocalizacion
      ).nombre
        }:`;
    },
  },
};
</script>

<style>
.w100 {
  max-width: 100px !important;
}

.input-right-text input {
  text-align: right;
}

.height-25 {
  height: 25px !important;
}
</style>
